import { cache } from 'react';
import { api } from '@weareconceptstudio/core';
import { universalApi } from './universalApi';

export const revalidate = 3600;

// ======================== Global Data ======================== //
export const getGlobal = cache(async ({ lang }) => {
	return await universalApi.get({ url: 'global-data', lang });
});

// ======================== Meta ======================== //
export const getMeta = cache(async ({ slug, lang }) => {
	return await api.get({ url: `meta/${slug}`, lang });
});

// ======================== Page ======================== //
export const getPage = cache(async ({ slug, lang, params = {} }) => {
	return await universalApi.get({ url: `page/${slug}`, lang, params });
});

// ======================== Blog Posts ======================== //
export const getPosts = cache(async ({ slug, lang, params = {} }) => {
	return await api.get({ url: 'posts', lang, params });
});

// ======================== Post Individual ======================== //
export const getPostIndividual = cache(async ({ slug, lang, params = {} }) => {
	return await api.get({ url: `posts/${slug}`, lang, params });
});

// ======================== Post Categories ======================== //
export const getPostCategories = cache(async ({ lang, params = {} }) => {
	return await api.get({ url: 'post-categories', lang, params });
});

// ======================== Related Posts ======================== //
export const getRelatedPosts = cache(async ({ currentPostId, postCategoryId, lang }) => {
	const { data } = await api.get({
		url: 'related-posts',
		lang,
		params: {
			currentPostId,
			postCategoryId,
		},
	});

	return data;
});

// ======================== Product Categories ======================== //
export const getMenu = cache(async ({ lang }) => {
	return await universalApi.get({ url: `menu`, lang });
});

// ======================== Product ======================== //
export const getProduct = cache(async ({ slug, lang, params = {} }) => {
	const { data } = await universalApi.get({ url: `product/${slug}`, lang, params });

	return data;
});

// ======================== Home Categories ======================== //
export const getHomeCategories = async ({ lang }) => {
	return await universalApi.get({ url: `home-categories`, lang });
};

// ======================== Most Wanted ======================== //
export const getMostWanted = async ({ lang }) => {
	const { data } = await universalApi.get({ url: `most-wanted-products`, lang });
	return data;
};

// ======================== Cart Product ======================== //
export const getCartProducts = async ({ lang }) => {
	const { data } = await universalApi.get({ url: `cart-products`, lang });
	return data;
};

// ======================== Faqs ======================== //
export const getFaqs = cache(async ({ lang }) => {
	const { data } = await api.get({ url: 'faqs', lang });

	return data;
});

export const getGoogleReviews = async () => {
	const featurableWidgetsKey = process.env.APP_GOOGLE_REVIEW_API_FEATURABLE_WIDGETS_KEY;

	const data = await fetch(`https://featurable.com/api/v1/widgets/${featurableWidgetsKey}`);

	return data.json();
};
